module.exports = __webpack_public_path__ + "media/dashboard/assets/images/opportunity-pipelines/empty-list-34d3c281c7a045504cb56ebd235c654d.svg";